import { render, staticRenderFns } from "./SystemTagsSection.vue?vue&type=template&id=dc904450"
import script from "./SystemTagsSection.vue?vue&type=script&lang=ts"
export * from "./SystemTagsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports